import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import SelectedPlan from '../views/SelectedPlan.vue'
import CardsPlansScreen from '../views/SelectScreenPlans.vue'
import ProposalSummary from '../views/ProposalSummary.vue'
import StartPlan from '../views/StartPlan.vue'
import FinancialPanel from '@/views/FinancialPanel.vue'
import NewAcceptTermScreen from '@/views/NewAcceptTermScreen.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/selected-plan-payment/:data',
    name: 'SelectedPlan',
    component: SelectedPlan
  },
  {
    path: '/selected-plan/:data',
    name: 'SelectScreenPlans',
    component: CardsPlansScreen
  },
  {
    path: '/proposal-summary/:data',
    name: 'ProposalSummary',
    component: ProposalSummary,
    meta: {
      title: 'Proposta Comercial',
    },
  },
  {
    path: '/start-plan/:customer/:code/:type?',
    name: 'StartPlan',
    component: StartPlan,
    meta: {
      title: 'Bem Vindo',
    },
  },
  {
    path: '/accept-term/:data',
    name: 'AcceptTerm',
    component: NewAcceptTermScreen,
    meta: {
      title: 'Termo de Aceite do Cliente',
    },
  },
  {
    path: '/financial-panel/:customer/:code',
    name: 'FinancialPanel',
    component: FinancialPanel,
    meta: {
      title: 'Painel Financeiro',
    },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
